import { useTraditionalLTCQuoteFetching } from '@/features/shop-insurance/hooks/use-traditional-ltc-quote-fetching';
import { useFilteredTraditionalLTCQuotes } from '@/features/shop-insurance/hooks/use-filtered-traditional-ltc-quotes';
import type { PaymentOption, BuyerOption } from '@/features/shop-insurance/types';

interface UseShopInsuranceTraditionalLTCParams {
  paymentOption: PaymentOption;
  selectedBuyerOption: BuyerOption;
  hasPartnerWithDemographics: boolean;
  advisorId: string;
  returnOnInvestmentCalculationType: ReturnOnInvestmentCalculationType;
}

export function useShopInsuranceTraditionalLTC({
  paymentOption,
  selectedBuyerOption,
  hasPartnerWithDemographics,
  advisorId,
  returnOnInvestmentCalculationType,
}: UseShopInsuranceTraditionalLTCParams) {
  useTraditionalLTCQuoteFetching({
    open: true,
    paymentOption,
    selectedBuyerOption,
    hasPartnerWithDemographics,
    advisorId,
  });

  const { filteredTraditionalLTCQuotes } = useFilteredTraditionalLTCQuotes({
    paymentOption,
    selectedBuyerOption,
    hasPartnerWithDemographics,
    returnOnInvestmentCalculationType,
  });

  return { filteredTraditionalLTCQuotes };
}
